var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturedArtist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1676_2389)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5.0223V6.99958L3.97309 6.99968L4 12.0001H2L1.99731 6.99987L1 6.99996V5.02268L1.99625 5.02259L1.99576 4.11418C1.99576 3.60021 2.09578 3.17395 2.29583 2.83541C2.71793 2.13191 3.28751 1.66584 4.48469 1.6888C4.9846 1.69839 5.38636 1.91023 5.73998 2.13078L5.29268 3.70854C5.03915 3.44834 4.5 3.34021 4.12857 3.59251C3.95776 3.70854 3.95776 3.91105 3.95776 4.15111L3.96245 5.0224L5 5.0223ZM10 5.00002V7.00002H9V9.70706C9 9.88864 9.0277 10.0302 9.0831 10.1318C9.27585 10.4744 9.72698 10.4334 10.0352 10.2944L10.43 11.8154C10.2327 11.877 9.87356 11.9816 9.36364 12C8.88968 12.0185 8.4742 11.9554 8.11719 11.8107C7.76326 11.6661 7.48781 11.4414 7.29084 11.1367C7.09387 10.8321 6.99692 10.4473 7 9.98262V7.00002H6V5.00002H7V3.00002H9V5.00002H10ZM12.291 11.7078C12.4879 11.9026 12.7243 12 13 12C13.1788 12 13.3424 11.9559 13.4909 11.8676C13.6424 11.7763 13.7636 11.6545 13.8546 11.5023C13.9485 11.3501 13.997 11.1811 14 10.9954C13.997 10.7215 13.8955 10.4871 13.6955 10.2922C13.4985 10.0974 13.2667 10 13 10C12.7243 10 12.4879 10.0974 12.291 10.2922C12.094 10.4871 11.997 10.7215 12.0001 10.9954C11.997 11.2755 12.094 11.5129 12.291 11.7078Z",
    fill: "#97A0A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1676_2389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedArtist);
export default __webpack_public_path__ + "static/media/FeaturedArtist.163726a7ddf1ef09e5e571efb16b0b20.svg";
export { ForwardRef as ReactComponent };